import React, { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { AnimatePresence, motion } from "framer-motion";

const IMG_BASE = `${process.env.PUBLIC_URL || ""}/images`;

const services = [
  { title: "Embedded", img: `${IMG_BASE}/embedded.jpeg` },
  { title: "Executive Search", img: `${IMG_BASE}/exsearch.jpg` },
  { title: "Contingency Hiring", img: `${IMG_BASE}/conthiring.jpg` },
];

export default function OurServicesSection() {
  const [open, setOpen] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const handleDropdownClick = (idx) => {
    if (isAnimating) return;
    if (open === idx) setOpen(-1);
    else {
      setIsAnimating(true);
      setOpen(-1);
      setTimeout(() => {
        setOpen(idx);
        setTimeout(() => setIsAnimating(false), 400);
      }, 300);
    }
  };

  return (
    // full-bleed white band
    <section className="bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8 md:pt-28 py-16">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Left: heading */}
          <div className="w-full lg:w-1/3 flex md:ml-10 items-start justify-start">
            <h2 className="block text-4xl font-bold text-black text-center mb-2 lg:hidden">
              Our Services
            </h2>
            <h2 className="hidden lg:block md:text-6xl md:leading-normal font-medium text-black leading-tight text-left whitespace-pre-line">
              {`Our\nServices`}
            </h2>
          </div>

          {/* Right: Accordions with images */}
          <div className="w-full lg:w-2/3">
            <div className="relative">
              {services.map((service, idx) => (
                <div key={service.title} className="mb-3">
                  <button
                    className="w-full flex items-center justify-between py-4 focus:outline-none"
                    onClick={() => handleDropdownClick(idx)}
                    aria-expanded={open === idx}
                  >
                    <span className="italic text-2xl md:text-3xl font-normal text-gray-900 text-left">
                      {service.title}
                    </span>
                    <motion.span
                      className="ml-4"
                      animate={{ rotate: open === idx ? 180 : 0 }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                    >
                      <FiChevronDown className="w-7 h-7 text-gray-900" />
                    </motion.span>
                  </button>

                  <div className="border-b border-gray-300" />

                  <AnimatePresence mode="wait">
                    {open === idx && (
                      <motion.div
                        initial={{ opacity: 0, y: -12 }}
                        animate={{ opacity: 1, y: 0, transition: { duration: 0.4, ease: [0.4, 0, 0.2, 1] } }}
                        exit={{ opacity: 0, y: -12, transition: { duration: 0.3, ease: [0.4, 0, 1, 1] } }}
                        className="py-4"
                      >
                        <div className="relative w-full rounded-2xl overflow-hidden shadow-md bg-white">
                          <div className="relative w-full h-[240px] sm:h-[300px] md:h-[360px] lg:h-[420px]">
                            <img
                              src={service.img}
                              alt={`${service.title} visual`}
                              className="absolute inset-0 w-full h-full object-contain"
                              loading="lazy"
                              decoding="async"
                              draggable="false"
                            />
                          </div>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
